import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	label: {
		id: 'platform-card.common.ui.key.key.styled-link.aria-label',
		defaultMessage: '{issueKey} is resolved',
		description: 'Label for the link in card key',
	},
});
